import ScrollBooster from 'scrollbooster';

export default function () {
    $(".password-eye").click(function () {
      $(this).toggleClass("eye-off");
      let input = $(this).prev("input");
      if (input.attr("type") == "password") {
          input.attr("type", "text");
      } else {
          input.attr("type", "password");
      }
  });
}
